import {ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot} from '@angular/router';
import {inject, Injectable} from "@angular/core";
import {CustomerService} from "../services/customer.service";
import {RouterService} from "../services/router.service";
import {ApiService} from '../services/api.service';
import {catchError, map, Observable, of, take} from 'rxjs';
import {LanguageService} from '../services/language.service';

@Injectable({
  providedIn: 'root'
})
export class customerGuard implements CanActivate {
  private customerService: CustomerService = inject(CustomerService);
  private apiService: ApiService = inject(ApiService);
  private languageService: LanguageService = inject(LanguageService);
  private routerService: RouterService = inject(RouterService);
  
  public canActivate(_route?: ActivatedRouteSnapshot, state?: RouterStateSnapshot): Observable<boolean> {
    const requestedUrl = state?.url ?? '/auth/login';
    if (this.customerService.getStoredCustomerKey()) {
      this.customerService.setCustomerKey(this.customerService.getStoredCustomerKey());
      if(this.customerService.publicCustomerResource()) {
        return of(!this.customerService.redirectToCustomerHost(this.customerService.getCustomerKey()!, requestedUrl));
      } else {
        return this.customerService.getPublicCustomerResourceCached(this.customerService.getCustomerKey()!)
          .pipe(
            take(1),
            map((customerPublicResource) => {
              this.customerService.setPublicCustomerResource(customerPublicResource);
              return !this.customerService.redirectToCustomerHost(this.customerService.getCustomerKey()!, requestedUrl);
            }),
            catchError(() => {
              this.customerService.resetCustomer();
              this.redirectToCustomerSelection();
              return of(false);
            })
          );
      }
    } else {
      this.redirectToCustomerSelection();
      return of(false);
    } 
  }

  private redirectToCustomerSelection(): void {
    this.routerService.navigateTo('/auth/customer');
  }
};
